import React, { useEffect, useRef, useState } from "react";
import { FormControl, Select, MenuItem, ListItemText } from "@mui/material";
import CopyToClipboard from "react-copy-to-clipboard";
import { CreatePortals, DropPortals, GetPortals } from "../../Services/Portals";
import { useTranslation } from "react-i18next";
const Url = process.env.REACT_APP_URl;


const Portals: React.FunctionComponent<{ onChangeMessagehandler: any }> = (props) => {

    const [loading, setLoading] = useState(false);
    const [platforms, setPlatforms] = useState<any>([{ name: "Coraly", src: "/assets/images/icons/coralytics.webp" }, { name: "Propcrm", src: "/assets/images/icons/propcrm.png" }, { name: "Property Finder", src: "/assets/images/icons/finder.png" }, { name: "Bayut", src: "/assets/images/icons/bayut.png" }, { name: "Dubizzle", src: "/assets/images/icons/dubizzle.png" }]);
    const [selectedPortals, setSelectedPortals] = useState([{ portal: '', url: '' }]);
    const [listPortals, setListPortals] = useState<any>([]);
    const [change, setChange] = useState(false);
    const [isCopied, setIsCopied] = useState<boolean>(false);
    const [portalValue, setPortalValue] = useState<any>("");
    const [isCoppiedCurl, setIsCoppiedCurl] = useState<boolean>(true);
    const { t } = useTranslation();
    const [portals, setPortals] = useState([
        { id: 1, name: "Property Finder", color: "#4B8BF5", initials: "PF" },
        { id: 2, name: "Bayut", color: "#23C26B", initials: "B" },
        { id: 3, name: "Dubizzle", color: "#F59A2A", initials: "D" },
        { id: 4, name: "Coraly", color: "#9333e9", initials: "C" },
        { id: 5, name: "Propcrm", color: "#F87171", initials: "P" },
    ]);

    useEffect(() => {
        GetPortals().then((data: any) => {
            setLoading(false)
            if (data.length == 0) {
                setListPortals([]);
            } else {
                setListPortals(data[0].urls);
            }
        }).catch(error => {
            console.log(error)
        })

    }, [change])

    const handleCopy = () => {
        setIsCopied(true)
        props.onChangeMessagehandler("success", "Url copied successfully!")
    };

    const handleChangePortal = (index: any, event: any) => {
        const newSelectedPortals = [...selectedPortals];
        newSelectedPortals[index].portal = event.target.value;
        newSelectedPortals[index].url = `${Url}/xml.feed.publish?platform=${newSelectedPortals[index].portal}&clientid=${localStorage.getItem('id')}`;
        setSelectedPortals(newSelectedPortals);
    };

    const handleChangeURL = (index: any, event: any) => {
        const newSelectedPortals = [...selectedPortals];
        newSelectedPortals[index].url = `${Url}/xml.feed.publish?platform=${newSelectedPortals[index].portal}&clientid=${localStorage.getItem('id')}`;
        setSelectedPortals(newSelectedPortals);
    };

    const addPortal = () => {
        setSelectedPortals([...selectedPortals, { portal: '', url: '' }]);
    };

    const isSaveDisabled = () => {
        return selectedPortals.some((item) => item.portal === '' || item.url === '');
    };

    const openLinkInNewTab = (url: any) => {
        window.open(url, '_blank');
    };

    const Drop = (portal: any) => {
        DropPortals(portal).then((resp: any) => {
            setChange(!change)
            props.onChangeMessagehandler("success", "Deleted Successfully!")
        }).catch((error: any) => {
            props.onChangeMessagehandler("error", "Error Delete Portals")
        })
    }

    const divRef = useRef<HTMLDivElement>(null);

    const handleCopyCurl = () => {
        const div = divRef.current;

        if (div) {
            const textToCopy = div.innerText;

            const tempTextArea = document.createElement('textarea');
            tempTextArea.value = textToCopy;

            // Append the text area to the document
            document.body.appendChild(tempTextArea);

            // Select the content
            tempTextArea.select();

            try {
                // Execute the copy command
                document.execCommand('copy');
                setIsCoppiedCurl(false)
                props.onChangeMessagehandler("success", "Api copied successfully!")
            } catch (err) {
                props.onChangeMessagehandler("error", "Unable to copy Api")

            } finally {
                // Remove the temporary text area from the document
                document.body.removeChild(tempTextArea);
            }
        }
    };

    const Save = () => {
        CreatePortals(selectedPortals).then((data: any) => {
            setSelectedPortals([{ portal: '', url: '' }]);
            setChange(!change)
            props.onChangeMessagehandler("success", "Created Successfully!")
        }).catch((error: any) => {
            props.onChangeMessagehandler("error", "Error Create Portals")
        })
    }


    return loading ? (<div> Loading ...</div>) : (
        <>

            <div className="cp-card mt-4 mb-4" style={{ overflowX: "auto" }}>
                <div className="cp-tabs">
                    <div className="cp-tab cp-tab-active">Link with Portal</div>
                    {/* <div className="cp-tab" >Sync from CRM</div>
                    <div className="cp-tab" >Link your website</div> */}
                </div>
                <div className="padd-20">
                    <div className="manager-header mb-4">
                        <h2 className="manager-title">Connected Portals</h2>
                    </div>
                    <div className="table-responsive text-nowrap ">
                        <table className="table" >
                            <thead className="table-thead">
                                <tr>
                                    <th>Logo</th>
                                    <th>Portal Name</th>
                                    <th>URL</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className="table-tbody">
                                {listPortals.length !== 0 && listPortals.map((p: any) => {
                                    // Find matching portal in predefined portals list
                                    const matchingPortal = portals.find(portal =>
                                        portal.name.toLowerCase() === p.portal.toLowerCase()
                                    );
                                    // Use matching portal's color and initials, or defaults
                                    const portalColor = matchingPortal ? matchingPortal.color : "#CBD5E1";
                                    const portalInitials = matchingPortal ? matchingPortal.initials : p.portal.charAt(0).toUpperCase();

                                    return <tr key={p._id}>
                                        <td className=" logo">
                                            <div className="logo-badge" style={{ background: portalColor }}>{portalInitials}</div>
                                        </td>
                                        <td>
                                            <div className="portal-name">{p.portal}</div>
                                        </td>
                                        <td>
                                            <div className="portal-url">{p.url}</div>
                                        </td>
                                        <td className="actions">
                                            <CopyToClipboard text={p.url} onCopy={handleCopy}>
                                                {isCopied ? <button className="icon-btn" id={`URL-copy-${p._id}`}>
                                                    <i className="fa-solid fa-check color-727272" ></i>
                                                </button>
                                                    : <button className="icon-btn" id={`URL-copy-${p._id}`}>
                                                        <i className="fa-solid fa-copy color-727272"></i>
                                                    </button>}
                                            </CopyToClipboard>
                                            <button
                                                className="icon-btn"
                                                id={`URL-open-${p._id}`}
                                                onClick={() => openLinkInNewTab(p.url)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <i className="fa-solid fa-up-right-from-square color-727272"></i>
                                            </button>
                                            <button className="icon-btn" key={`${p._id}-api`} onClick={() => setPortalValue(p.portal)} data-bs-toggle="modal" data-bs-target="#api">
                                                <i className="fa fa-eye color-727272" aria-hidden="true"></i>
                                            </button>
                                            <button
                                                className="icon-btn"
                                                id={`delete-${p._id}`}
                                                onClick={() => Drop(p.portal)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <i className="fa fa-trash  color-727272" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                        {listPortals && listPortals.length == 0 && <h3 className="empty">No Portals found</h3>}

                    </div>

                    <div className="add-line">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <button className="logo-badge back-64748B marg-left-20" onClick={addPortal}>
                                <i className="fa-solid fa-plus"></i>
                            </button>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {selectedPortals.map((item, index) => (
                                <div className="cp-row" key={`${index}-selectPortal`} style={{ padding: "0px", gridTemplateColumns: '1fr 2fr', gap: "12px", alignItems: 'center' }}>
                                    <div className="cp-col">
                                        <FormControl fullWidth>
                                            <Select
                                                className="input-settings"
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'Select Portal' }}
                                                value={item.portal}
                                                onChange={(e) => handleChangePortal(index, e)}
                                                renderValue={(value) => value || 'Select Portal'}
                                            >
                                                <MenuItem value="" disabled>
                                                    Select Portal
                                                </MenuItem>
                                                {platforms.map((platform: any, idx: any) => (
                                                    <MenuItem value={platform.name} key={idx}>
                                                        <img
                                                            src={platform.src}
                                                            style={{ width: "auto", maxHeight: "20px", marginRight: "10px" }}
                                                            alt={platform.name}
                                                        />
                                                        <ListItemText primary={platform.name} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="cp-col">
                                        <input
                                            type="text"
                                            id={`URL-${index}`}
                                            className="form-control input-settings"
                                            placeholder="http://..."
                                            value={item.url}
                                            onChange={(e) => handleChangeURL(index, e)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>

                        <button className="save-settings" onClick={Save} disabled={isSaveDisabled()}>
                            Save
                        </button>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="api" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="title-18" >   {t("propertiesPage.apiDocumentation")}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body mt-3">
                            <div className="custom-curl ">
                                <pre>
                                    <div className="mb-3">
                                        <a id="button-addnew" onClick={handleCopyCurl} style={{ float: "right", color: "white", border: " 1px solid #000000" }}>

                                            <i className="fa-solid fa-copy" style={{ marginRight: "5px" }}></i>
                                            {isCoppiedCurl ? <> {t("listingCreation.copy")}</> : <>{t("listingCreation.copied")} !</>}
                                        </a>
                                    </div>
                                    <code ref={divRef}>
                                        <span style={{ color: 'blue' }}>curl -X GET </span> {Url + "/listing_publish_api?platform=" + portalValue + "&clientid=" + localStorage.getItem('id')} {'\\'} <br />
                                        <span style={{ color: 'blue' }}>-H 'Authorization</span>: Bearer {localStorage.getItem("usertoken") + "'"} {'\\'} <br />
                                    </code>
                                </pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Portals
